"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CLEAR = exports.FETCH_FAILED = exports.FETCH_SUCCESS = exports.FETCH_REQUEST = exports.iItem = void 0;
const t = require("io-ts");
const sok_types_1 = require("@caddigital/sok-types");
exports.iItem = t.interface({
    project: sok_types_1.Project.iProject,
    subproject: sok_types_1.File.iFolder
});
exports.FETCH_REQUEST = `@sok/subproject/list/FETCH_REQUEST`;
exports.FETCH_SUCCESS = `@sok/subproject/list/FETCH_SUCCESS`;
exports.FETCH_FAILED = `@sok/subproject/list/FETCH_FAILED`;
exports.CLEAR = '@sok/subproject/list/CLEAR';
//# sourceMappingURL=list.js.map